<template>
  <div>
    <div class="spaceBetween search-box">
      <span class="search-title">Producer Authentication List</span>
      <div class="spaceLeft search-form">
        <search-select
          @valChange="valChange($event, 'status')"
          label="Status"
          :options="producerAuthSatatus"
          :defaultValue="searchData.status"
        />
        <div class="search-item">
          <el-input
            class="search-input"
            v-model="searchData.username"
            placeholder="Username"
            @keyup.enter="getList"
          >
            <el-button slot="append" size="mini" @click="getList">
              <svg-icon icon-class="tn-search" />
            </el-button>
          </el-input>
        </div>
        <div class="search-item">
          <el-input
            class="search-input"
            v-model="searchData.account"
            placeholder="treasurenet Account"
            @keyup.enter="getList"
          >
            <el-button slot="append" size="mini" @click="getList">
              <svg-icon icon-class="tn-search" />
            </el-button>
          </el-input>
        </div>
      </div>
    </div>

    <div class="pad">
      <el-table
        stripe
        :data="tableList"
        v-loading="loading"
        highlight-current-row
      >
        <el-table-column
          prop="registrationDate"
          label="Date"
          show-overflow-tooltip
        >
          <template slot-scope="{ row }">
            {{ moment(row.registrationDate).format("YYYY-MM-DD HH:mm") }}
          </template>
        </el-table-column>
        <el-table-column prop="username" label="Username" />
        <el-table-column prop="account" label="treasurenet Account">
          <template slot-scope="{ row }">
            <account v-if="row.account" :value="row.account" />
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column prop="statusEth" label="Type" align="center">
          <template>
            <div class="td-split spaceCenter">BTC</div>
            <div class="td-split spaceCenter">ETH</div>
          </template>
        </el-table-column>
        <el-table-column prop="account" label="Account">
          <template slot-scope="{ row }">
            <div class="td-split spaceLeft">
              <account v-if="row.btcAccount" :value="row.btcAccount" />
              <span v-else>--</span>
            </div>
            <div class="td-split spaceLeft">
              <account v-if="row.ethAccount" :value="row.ethAccount" />
              <span v-else>--</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="Status">
          <template slot-scope="{ row }">
            <div class="td-split spaceLeft">
              <authStatus v-if="row.statusBtc" :status.sync="row.statusBtc" />
              <span v-else>--</span>
            </div>
            <div class="td-split spaceLeft">
              <authStatus v-if="row.statusEth" :status.sync="row.statusEth" />
              <span v-else>--</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="Operation" label="Operation" width="200px">
          <template slot-scope="{ row }">
            <div class="td-split spaceLeft">
              <template v-if="row.statusBtc == 1">
                <span
                  class="text-link"
                  @click="toApprove('btc', row, 'notReceived')"
                  >Not received</span
                >
                <span
                  class="text-link"
                  @click="toApprove('btc', row, 'refund')"
                  >Refund</span
                >
              </template>
              <span v-else>--</span>
            </div>
            <div class="td-split spaceLeft">
              <template v-if="row.statusEth == 1">
                <span
                  class="text-link"
                  @click="toApprove('eth', row, 'notReceived')"
                  >Not received</span>
                <span
                  class="text-link"
                  @click="toApprove('eth', row, 'refund')"
                  >Refund</span
                >
              </template>
              <span v-else>--</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="table-bottom-btn">
        <pagination
          :total="queryParams.total"
          :page.sync="queryParams.page"
          :limit.sync="queryParams.eachpage"
          @pagination="getList()"
        />
      </div>
    </div>
    <digitalDialog ref="digitalDialog" @success="success" />
    <editInformationSuccess ref="editInformationSuccess" @close="refresh" />
  </div>
</template>

<script>
import { producerList } from "@/api/manager.js";
import authStatus from "./authStatus.vue";
import digitalDialog from "./digitalDialog.vue";
import editInformationSuccess from "@/views/authentication/editInformationSuccess.vue";
export default {
  components: { authStatus, digitalDialog, editInformationSuccess },
  data() {
    return {
      loading: false,
      searchData: {
        status: 1,
        username:undefined,
        account:undefined
      },
      tableList: [],
      queryParams: {
        total: 0,
        page: 1,
        eachpage: 10,
      },
      producerAuthSatatus: this.$store.getters.producerAuthSatatus,
    };
  },
  computed: {},
  methods: {
     valChange(data, key){
      this.searchData[key] = data.value;
      this.getList();
    },
    getList() {
      const param = {
        type: "digital",
        page: this.queryParams.page,
        eachpage: this.queryParams.eachpage,
        ...this.searchData,
        sortField:"registrationDate",
        sequence:"DESC"
      };
      this.loading = true;
      producerList(param)
        .then((res) => {
          this.tableList = res.result.list;
          this.queryParams.total = res.result.total;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    toApprove(digitalType, row, type) {
      if(this.CheckAccount().res != "1"){
        return;
      }
      this.$refs.digitalDialog.open({
        digitalType,
        row,
        type,
      });
    },
    success() {
      this.$refs.editInformationSuccess.open();
    },
    refresh() {
      this.getList();
    },
  },
  created() {
    this.getList();
  },
};
</script>
<style scoped lang="scss">
.pad {
  padding: 0.04rem 0.32rem;

  ::v-deep.el-table .cell {
    padding-left: 0 !important;
    padding-right: 0 !important;

  }
  ::v-deep .el-table td{
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
}
.search-box{
  padding:0.24rem 0.32rem;
  border-bottom:1px solid #F0F0F0;

  .search-title{
    font-size: 0.22rem;
    font-weight: bold;
  }
  .search-item{
    margin-left: 0.24rem;
  }
}
.td-split {
  height: 0.46rem;
  box-sizing: border-box;
  &:first-child {
    border-bottom: 0.01rem solid #f0f0f0;
  }
}

</style>
